import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "../../../utils/config";
import CustomForm from "../../../components/CustomForm/CustomForm";
import { adminRequest } from "../../../utils/requestMethods";
import Loader from "../../../components/Loader/Loader";

const EditSubject = () => {
  const location = useLocation();
  const activeURL = location.pathname.split("/")[6];
  const initialFormData = {
    subject_name: "",
    subject_description: "",
    credit_hour: "",
    subject_code: "",
  };

  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialFormData);
  const [data, setData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchSubject = async () => {
      try {
        const response = await adminRequest.post(
          `${BASE_URL}/course/subject/view`,
          {
            uuid: `${activeURL}`,
          },
        );
        setData(response.data);
        setFormData({
          subject_name: response.data.data.subject_name,
          subject_description: response.data.data.subject_description,
          credit_hour: response.data.data.credit_hour,
          subject_code: response.data.data.subject_code,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchSubject();
  }, [activeURL]);

  if (!data || !data.data) {
    return <Loader />;
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await toast.promise(
        adminRequest.post(`${BASE_URL}/course/subject/update`, {
          uuid: activeURL,
          subject_name: formData.subject_name,
          subject_description: formData.subject_description,
          credit_hour: formData.credit_hour,
          subject_code: formData.subject_code,
        }),
        {
          pending: "Updating Subject",
        },
      );

      toast.success(response.data.message, {
        autoClose: 500,
        onClose: () => navigate(-1),
      });

      setFormData(initialFormData);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const fields = [
    {
      name: "subject_name",
      label: "Subject Name",
      type: "text",
      value: formData.subject_name,
      onChange: handleChange,
    },
    {
      name: "subject_description",
      label: "Subject Description",
      type: "text",
      value: formData.subject_description,
      onChange: handleChange,
    },
    {
      name: "credit_hour",
      label: "Credit Hour",
      type: "text",
      value: formData.credit_hour,
      onChange: handleChange,
    },
    {
      name: "subject_code",
      label: "Subject Code",
      type: "text",
      value: formData.subject_code,
      onChange: handleChange,
    },
  ];
  return (
    <div className="editSubjectContainer">
      <CustomForm
        header="Edit Subject"
        fields={fields}
        flexDirection="row"
        createButtonLabel="Update"
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
      <ToastContainer position="top-center" />
    </div>
  );
};

export default EditSubject;
